var map = {
	"./": [
		184,
		9
	],
	"./BottomBar": [
		834,
		9,
		287
	],
	"./BottomBar.tsx": [
		834,
		9,
		287
	],
	"./ReadabilityOverlay": [
		828,
		9,
		408
	],
	"./ReadabilityOverlay.tsx": [
		828,
		9,
		408
	],
	"./background": [
		800,
		9,
		487
	],
	"./background.style": [
		801,
		9,
		760
	],
	"./background.style.ts": [
		801,
		9,
		760
	],
	"./background.tsx": [
		800,
		9,
		487
	],
	"./bottomBar.style": [
		826,
		9,
		761
	],
	"./bottomBar.style.ts": [
		826,
		9,
		761
	],
	"./defaultBackgroundImage": [
		1386,
		9,
		762
	],
	"./defaultBackgroundImage.tsx": [
		1386,
		9,
		762
	],
	"./fullscreenSubcontent": [
		249,
		9
	],
	"./fullscreenSubcontent.tsx": [
		249,
		9
	],
	"./gallery": [
		359,
		9,
		63
	],
	"./gallery/": [
		359,
		9,
		63
	],
	"./gallery/GalleryBackground": [
		897,
		9,
		306
	],
	"./gallery/GalleryBackground.tsx": [
		897,
		9,
		306
	],
	"./gallery/GalleryPanel": [
		846,
		9,
		763
	],
	"./gallery/GalleryPanel.tsx": [
		846,
		9,
		763
	],
	"./gallery/ImageGallery": [
		893,
		9,
		210
	],
	"./gallery/ImageGallery.tsx": [
		893,
		9,
		210
	],
	"./gallery/ImageGalleryModule": [
		845,
		9,
		764
	],
	"./gallery/ImageGalleryModule.tsx": [
		845,
		9,
		764
	],
	"./gallery/PanelSlider": [
		1387,
		9,
		765
	],
	"./gallery/PanelSlider.tsx": [
		1387,
		9,
		765
	],
	"./gallery/galleryBackground.style": [
		853,
		9,
		766
	],
	"./gallery/galleryBackground.style.ts": [
		853,
		9,
		766
	],
	"./gallery/imageGallery.style": [
		907,
		9,
		767
	],
	"./gallery/imageGallery.style.ts": [
		907,
		9,
		767
	],
	"./gallery/index": [
		359,
		9,
		63
	],
	"./gallery/index.tsx": [
		359,
		9,
		63
	],
	"./graphics": [
		521,
		9,
		7,
		23,
		143
	],
	"./graphics/": [
		521,
		9,
		7,
		23,
		143
	],
	"./graphics/GraphicsBackground": [
		1291,
		9,
		7,
		23
	],
	"./graphics/GraphicsBackground.tsx": [
		1291,
		9,
		7,
		23
	],
	"./graphics/GraphicsPanel": [
		1277,
		9,
		279
	],
	"./graphics/GraphicsPanel.tsx": [
		1277,
		9,
		279
	],
	"./graphics/graphicsBackground.style": [
		1276,
		9,
		768
	],
	"./graphics/graphicsBackground.style.ts": [
		1276,
		9,
		768
	],
	"./graphics/index": [
		521,
		9,
		7,
		23,
		143
	],
	"./graphics/index.tsx": [
		521,
		9,
		7,
		23,
		143
	],
	"./image": [
		346,
		9,
		74
	],
	"./image/": [
		346,
		9,
		74
	],
	"./image/ImageBackground": [
		840,
		9,
		318
	],
	"./image/ImageBackground.tsx": [
		840,
		9,
		318
	],
	"./image/ImagePanel": [
		809,
		9,
		769
	],
	"./image/ImagePanel.tsx": [
		809,
		9,
		769
	],
	"./image/imageBackground.style": [
		830,
		9,
		770
	],
	"./image/imageBackground.style.ts": [
		830,
		9,
		770
	],
	"./image/index": [
		346,
		9,
		74
	],
	"./image/index.tsx": [
		346,
		9,
		74
	],
	"./index": [
		184,
		9
	],
	"./index.ts": [
		184,
		9
	],
	"./interactivePanel": [
		827,
		9,
		355
	],
	"./interactivePanel.style": [
		820,
		9,
		771
	],
	"./interactivePanel.style.ts": [
		820,
		9,
		771
	],
	"./interactivePanel.tsx": [
		827,
		9,
		355
	],
	"./quizzes": [
		522,
		9,
		0,
		14,
		13,
		19,
		141
	],
	"./quizzes/": [
		522,
		9,
		0,
		14,
		13,
		19,
		141
	],
	"./quizzes/DragAndDrop/AnswerImage": [
		1075,
		9,
		0,
		14,
		13
	],
	"./quizzes/DragAndDrop/AnswerImage.tsx": [
		1075,
		9,
		0,
		14,
		13
	],
	"./quizzes/DragAndDrop/DragAndDropQuestion": [
		1279,
		9,
		0,
		14,
		13,
		362
	],
	"./quizzes/DragAndDrop/DragAndDropQuestion.tsx": [
		1279,
		9,
		0,
		14,
		13,
		362
	],
	"./quizzes/DragAndDrop/ImageList": [
		1069,
		9,
		0,
		14,
		13,
		488
	],
	"./quizzes/DragAndDrop/ImageList.tsx": [
		1069,
		9,
		0,
		14,
		13,
		488
	],
	"./quizzes/DragAndDrop/answerImage.style": [
		1278,
		9,
		772
	],
	"./quizzes/DragAndDrop/answerImage.style.ts": [
		1278,
		9,
		772
	],
	"./quizzes/DragAndDrop/dragAndDropQuestion.style": [
		1070,
		9,
		773
	],
	"./quizzes/DragAndDrop/dragAndDropQuestion.style.ts": [
		1070,
		9,
		773
	],
	"./quizzes/DragAndDrop/imageList.style": [
		957,
		9,
		774
	],
	"./quizzes/DragAndDrop/imageList.style.ts": [
		957,
		9,
		774
	],
	"./quizzes/MultipleChoice/CheckBox": [
		1071,
		9,
		342
	],
	"./quizzes/MultipleChoice/CheckBox.tsx": [
		1071,
		9,
		342
	],
	"./quizzes/MultipleChoice/ChoiceQuestion": [
		1280,
		9,
		290
	],
	"./quizzes/MultipleChoice/ChoiceQuestion.tsx": [
		1280,
		9,
		290
	],
	"./quizzes/MultipleChoice/checkBox.style": [
		958,
		9,
		775
	],
	"./quizzes/MultipleChoice/checkBox.style.ts": [
		958,
		9,
		775
	],
	"./quizzes/MultipleChoice/choiceQuestion.style": [
		1072,
		9,
		776
	],
	"./quizzes/MultipleChoice/choiceQuestion.style.ts": [
		1072,
		9,
		776
	],
	"./quizzes/Quiz": [
		1281,
		9,
		0,
		14,
		13,
		19
	],
	"./quizzes/Quiz.tsx": [
		1281,
		9,
		0,
		14,
		13,
		19
	],
	"./quizzes/QuizBackground": [
		1284,
		9,
		0,
		14,
		13,
		19,
		409
	],
	"./quizzes/QuizBackground.tsx": [
		1284,
		9,
		0,
		14,
		13,
		19,
		409
	],
	"./quizzes/QuizResults": [
		1283,
		9,
		333
	],
	"./quizzes/QuizResults.tsx": [
		1283,
		9,
		333
	],
	"./quizzes/index": [
		522,
		9,
		0,
		14,
		13,
		19,
		141
	],
	"./quizzes/index.tsx": [
		522,
		9,
		0,
		14,
		13,
		19,
		141
	],
	"./quizzes/prismic": [
		1067,
		9,
		0,
		489
	],
	"./quizzes/prismic.ts": [
		1067,
		9,
		0,
		489
	],
	"./quizzes/quiz.style": [
		1282,
		9,
		490
	],
	"./quizzes/quiz.style.ts": [
		1282,
		9,
		490
	],
	"./quizzes/quizResults.style": [
		1073,
		9,
		777
	],
	"./quizzes/quizResults.style.ts": [
		1073,
		9,
		777
	],
	"./quizzes/quizTypes": [
		1068,
		9,
		0,
		778
	],
	"./quizzes/quizTypes.ts": [
		1068,
		9,
		0,
		778
	],
	"./quizzes/quiz_bg.png": [
		2219,
		9,
		1550
	],
	"./quizzes/quizzesStore": [
		894,
		9,
		0,
		363
	],
	"./quizzes/quizzesStore.ts": [
		894,
		9,
		0,
		363
	],
	"./scrollytelling": [
		523,
		9,
		0,
		1,
		3,
		5,
		30
	],
	"./scrollytelling/": [
		523,
		9,
		0,
		1,
		3,
		5,
		30
	],
	"./scrollytelling/ScrollytellingBackground": [
		1285,
		9,
		0,
		1,
		3,
		5,
		213
	],
	"./scrollytelling/ScrollytellingBackground.tsx": [
		1285,
		9,
		0,
		1,
		3,
		5,
		213
	],
	"./scrollytelling/index": [
		523,
		9,
		0,
		1,
		3,
		5,
		30
	],
	"./scrollytelling/index.tsx": [
		523,
		9,
		0,
		1,
		3,
		5,
		30
	],
	"./scrollytelling/scrollytellingBackground.style": [
		1074,
		9,
		779
	],
	"./scrollytelling/scrollytellingBackground.style.ts": [
		1074,
		9,
		779
	],
	"./subcontentInterfaces": [
		1388,
		7,
		780
	],
	"./subcontentInterfaces.ts": [
		1388,
		7,
		780
	],
	"./text": [
		365,
		9,
		64
	],
	"./text/": [
		365,
		9,
		64
	],
	"./text/TextBackground": [
		928,
		9,
		295
	],
	"./text/TextBackground.tsx": [
		928,
		9,
		295
	],
	"./text/TextPanel": [
		899,
		9,
		781
	],
	"./text/TextPanel.tsx": [
		899,
		9,
		781
	],
	"./text/index": [
		365,
		9,
		64
	],
	"./text/index.tsx": [
		365,
		9,
		64
	],
	"./text/supportingMaterial": [
		898,
		9,
		491
	],
	"./text/supportingMaterial.style": [
		884,
		9,
		782
	],
	"./text/supportingMaterial.style.ts": [
		884,
		9,
		782
	],
	"./text/supportingMaterial.tsx": [
		898,
		9,
		491
	],
	"./text/textBackground.style": [
		854,
		9,
		783
	],
	"./text/textBackground.style.ts": [
		854,
		9,
		783
	],
	"./video": [
		354,
		9,
		0,
		1,
		3,
		4,
		52
	],
	"./video/": [
		354,
		9,
		0,
		1,
		3,
		4,
		52
	],
	"./video/VideoBackground": [
		882,
		9,
		0,
		1,
		3,
		4,
		265
	],
	"./video/VideoBackground.tsx": [
		882,
		9,
		0,
		1,
		3,
		4,
		265
	],
	"./video/VideoPanel": [
		814,
		9,
		784
	],
	"./video/VideoPanel.tsx": [
		814,
		9,
		784
	],
	"./video/index": [
		354,
		9,
		0,
		1,
		3,
		4,
		52
	],
	"./video/index.tsx": [
		354,
		9,
		0,
		1,
		3,
		4,
		52
	],
	"./video/videoBackground.style": [
		847,
		9,
		785
	],
	"./video/videoBackground.style.ts": [
		847,
		9,
		785
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1937;
module.exports = webpackAsyncContext;